export default "__VITE_ASSET__8Tm$NxEo__"